import React, { useState, useEffect } from "react";
import ViewLeaveDetailsStyles from "./ViewLeaveDetailsStyles";
import { Typography, Grid, Box } from "@mui/material";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";
import { useAppSelector } from "../../../../../utils/hooks";
import { selectUserId } from "../../../../../redux/authSlice";
import { getLeaveDetails } from "../StepperServices";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
interface CustomProps {
  nextStep?: () => void | undefined;
  backStep?: () => void | undefined;
}

const ViewLeaveDetails = (props: CustomProps) => {
  const classes = ViewLeaveDetailsStyles;
  const [LeaveInfo, setLeaveInfo] = useState<any>([]);
  const userIdFromRedux = useAppSelector(selectUserId);
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setApiResponse(true);
      const response = await getLeaveDetails(userIdFromRedux);
      customErrorHandler(response);
      setLeaveInfo(response.data);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  return (
    <Box sx={classes.contentWrapper}>
      <Box sx={classes.pageInfoHeader}>
        <Typography sx={classes.Heading}>Leave Information</Typography>
        <Typography sx={classes.text}>
          Update your Bank information for the platform
        </Typography>
      </Box>
      <Grid container>
        <Box sx={classes.profileDetails}>
          <Grid container rowSpacing={3}>
            <Grid item xs={12}>
              <Typography sx={classes.detailsHeading}>Leave Details</Typography>
              <Typography sx={classes.subHeading}>
                Manage your bank information to use the platform
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Total Leave</Typography>
              <Typography sx={classes.userDetails}>
                {LeaveInfo?.total_leave}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Earned Leave</Typography>
              <Typography sx={classes.userDetails}>
                {LeaveInfo?.earned_leave}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Sick Leave</Typography>
              <Typography sx={classes.userDetails}>
                {LeaveInfo?.sick_leave}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={classes.userLabal}>Casual Leave</Typography>
              <Typography sx={classes.userDetails}>
                {LeaveInfo?.casual_leave}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Grid item xs={4}>
          <Box sx={classes.buttonWarapper}>
            <CustomButton
              label="Back"
              buttonType="secondaryBtn"
              onClick={() => {
                props.backStep?.();
              }}
            />
            <CustomButton
              label="Next"
              buttonType="primaryBtn"
              onClick={() => {
                props.nextStep?.();
              }}
            />
          </Box>
        </Grid>
      </Grid>
      {apiResponse && <CustomLoader apiResponse={false} />}
    </Box>
  );
};

export default ViewLeaveDetails;
